

import { defineComponent, reactive, inject, ref } from "vue"
import type { FormInstance, FormRules, UploadInstance, UploadProps } from "element-plus"

//services
import JwtService from "@/core/services/JwtService";
import Tramite from "@/core/services/TramiteService";

//libs
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import {errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "DialogRectify",
    props: {
        expediente: Object
    },
    setup(props, {emit}){

        const open_dialog_rectify = inject("open_dialog_rectify")
        const ruleFormRef = ref < FormInstance > ()
        const idFiles = ref < any []> ([])
        const upload = ref<UploadInstance>()
        const submitButton = ref < HTMLButtonElement | null > (null);
        const urlUpload = ref(process.env.VUE_APP_API_URL)
        const headers = ref({
            Authorization: `Bearer ${JwtService.getToken()}`
        })
         const form = reactive({
            idtramite: "",
            nro_proceedings: "",
            created_at: "",
            nrofolios: 0,
            mstatus: 4,
            message: "",
            isMail: false,
            idFiles: <any>[]
        })
        
        const rules = reactive < FormRules > ({
            nrofolios: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }, ],
            message: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }, ]
        })

        const onOpen = () => {
            resetForm(ruleFormRef.value)
            idFiles.value.splice(0, idFiles.value.length);
            upload.value!.clearFiles()
        
            const date = new Date();
            const fecha = date.toLocaleDateString('es-ES', {year: 'numeric', month: '2-digit', day: '2-digit'}).replace(/\//g, '-');
            const hora  = date.toLocaleTimeString();
            form.created_at = fecha  + " " + hora;
            form.idtramite = props.expediente?.idtramite
            form.nro_proceedings = props.expediente?.nro_proceedings
            form.message = props.expediente?.message
            form.nrofolios = props.expediente?.nrofolios
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const handleExceed: UploadProps['onExceed'] = (files) => {
            Swal.fire({
                text: "Solo puede anexar hasta tres (3) archivos y cinco (5) megas como máximo en formato PDF",
                icon: "info",
                buttonsStyling: false,
                confirmButtonText: "Entendido!",
                customClass: {
                    confirmButton: "btn fw-bold btn-light-info",
                },
            });
        };

        const beforeUpload: UploadProps['beforeUpload'] = (rawFile) => {
            if (rawFile.type !== 'application/pdf') {
                Swal.fire({
                    text: "¡El archivo seleccionado debe ser en formato PDF!",
                    icon: "info",
                    buttonsStyling: false,
                    confirmButtonText: "Entendido!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-info",
                    },
                });
                return false
            } else if (rawFile.size > 5000000) {
                Swal.fire({
                    text: "El archivo seleccionado supera los 5MB permitidos!",
                    icon: "info",
                    buttonsStyling: false,
                    confirmButtonText: "Entendido!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-info",
                    },
                });
                return false
            }
            return true
        };

         const handleError: UploadProps['onError'] = (error, uploadFile) => {
            const e = JSON.parse(error.message);
            console.log(e)
            Swal.fire({
                title: e.title,
                text: e.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Intentar otra vez!",
                customClass: {
                        confirmButton: "btn fw-bold btn-light-danger",
                },
            });
        }

        const handleSuccess: UploadProps['onSuccess'] = (response, uploadFile) => {
            idFiles.value.push(response.idFile);
        }

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    upload.value!.submit()
                    saveForm()
                }
                    
            });
        };

         const saveForm = async () => {
            submitButton.value!.disabled = true;
            submitButton.value ?.setAttribute("data-kt-indicator", "on");
            form.idFiles = (idFiles.value)
            await Tramite.Attend(form)
            .then( (res) => {
                submitButton.value!.disabled = false;
                submitButton.value ?.removeAttribute("data-kt-indicator");
                Swal.fire({
                    text: res.data.message,
                    icon: res.data.status,
                    buttonsStyling: false,
                    confirmButtonText: "Ok!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                    },
                }).then( ()=>{
                    emit("resDialogRectify", res.data)
                })
            }).catch ( ({response }) => {
                submitButton.value!.disabled = false;
                submitButton.value ?.removeAttribute("data-kt-indicator");
                errManager(response);
            })
        }

        return{
            open_dialog_rectify,
            headers,
            urlUpload,
            ruleFormRef,
            form,
            rules,
            idFiles,
            upload,
            onOpen,
            handleExceed,
            beforeUpload,
            handleError,
            handleSuccess,
            submitForm,
            submitButton,
        }
    }
})
